// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class GenderVm {
    @AutoMap() id: number;
    @AutoMap() timeStamp: string;
    @AutoMap() name: string;
    @AutoMap() exactCode?: any;
    @AutoMap() creditManagerCode: string;
    @AutoMap() inactive: boolean;
    @AutoMap() localizableEntry_Id?: any;
    @AutoMap() createdDate: Date;
    @AutoMap() createdBy: string;
    @AutoMap() lastModifiedDate: Date;
    @AutoMap() lastModifiedBy: string;
}
